<template>
  <div class="animated fadeIn mb-3">
    <h4>Cleaner History</h4>
    <hr >
    <b-row>
      <b-col>
        <select
          v-model="selectedCleaner"
          class="form-control w-25"
          @change="loadData">
          <option
            value="null"
            disabled>--Please select cleaner--</option>
          <option
            v-for="cleaner in cleaners"
            :key="cleaner.CODE"
            :value="cleaner.CODE">{{ cleaner.USER_PROFILE_FIRST_NAME + ' ' + cleaner.USER_PROFILE_LAST_NAME }}</option>
        </select>
      </b-col>
    </b-row>
    <b-row
      v-if="selectedCleaner"
      class="mt-3">
      <b-col>
        <b-tabs
          v-model="tabIndex"
          @input="loadData">
          <b-tab
            v-for="range in reportRange"
            :title="range"
            :key="range">

            <div>
              <date-picker
                v-if="tabIndex < 2"
                v-model="dateFilter"
                lang="en"/>
              <date-picker
                v-if="tabIndex > 1"
                v-model="dateFilter"
                lang="en"
                type="month"
                format="YYYY-MM"/>
              <b-btn
                :disabled="!dateFilter || isFetching"
                variant="primary"
                class="ml-2"
                size="sm"
                @click="loadData">Search</b-btn>
              <b-btn
                :disabled="isFetching || !items.length"
                class="float-right"
                variant="success"
                type="button"
                size="sm"
                @click="exportReport">
                <i class="fa fa-file-excel-o"/>
                Download
              </b-btn>
              <h5
                v-show="!items.length && !isFetching"
                class="text-center">Data is Empty</h5>

              <div
                v-if="isFetching"
                style="margin: 0 auto; width: 10px;">
                <div class="loader-dark-blue medium mb-5 mt-5"/>
              </div>

              <b-table
                v-if="items.length && !isFetching"
                :items="items"
                :fields="fields"
                :per-page="itemsPerPage"
                :current-page="currentPage"
                class="mt-3"
                striped
                responsive>
                <template
                  v-slot:cell(STATION)="row">
                  {{ row.item.CIST.STATION.NAME || row.item.STATION.NAME || '-' }}
                </template>
                <template
                  v-slot:cell(CAR)="row">
                  {{ row.item.CIST.CAR.NAME || row.item.CAR.NAME }} - {{ row.item.CIST.CAR.LICENSE_PLATE || row.item.CAR.LICENSE_PLATE }}
                </template>
                <template
                  v-slot:cell(STATUS)="data">
                  <span
                    :class="{'badge-success': data.value > 0, 'badge-warning': data.value < 1}"
                    class="badge">
                    {{ data.value > 0 ? 'Reviewd' : 'Unreviewed' }}
                  </span>
                </template>

              </b-table>
              <b-pagination
                v-show="!isFetching && items.length > 10"
                :total-rows="items.length"
                :per-page="itemsPerPage"
                v-model="currentPage" />
            </div>

          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { server, helperService, toastr } from '@/services/'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import FileSaver from 'file-saver'
import { mapState } from 'vuex'

export default {
  name: 'HistoryReport',
  components: {
    DatePicker
  },
  data () {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      fields: [
        'STATION',
        'CAR',
        'LOG_DATE',
        'STATUS'
      ],
      selectedCleaner: null,
      reportRange: ['Daily', 'Weekly', 'Monthly'],
      // cleaners: [],
      tabIndex: 0,
      isEmpty: false,
      dateFilter: new Date()
    }
  },
  computed: {
    ...mapState('cleanerHistory', {
      isFetching: state => state.isFetching,
      cleaners: state => state.cleaners,
      items: state => state.cleanerHistories
    })
  },
  mounted () {
    this.$store.cache.dispatch('cleanerHistory/fetchCleaners')
  },
  methods: {
    loadData () {
      this.$store.commit('cleanerHistory/setIsFetching', true)

      let dateParam = ''
      if (this.tabIndex === 0) {
        dateParam = moment(this.dateFilter).format('YYYY-MM-DD')
      } else if (this.tabIndex === 1) {
        dateParam = moment(this.dateFilter).subtract(7, 'days').format('YYYY-MM-DD')
      } else {
        dateParam = moment(this.dateFilter).format('YYYY-MM')
      }

      let payload = {
        type: this.tabIndex,
        uaCode: this.selectedCleaner,
        date: dateParam
      }

      let promises = [
        this.$store.cache.dispatch('cleanerHistory/fetchZones'),
        this.$store.cache.dispatch('cleanerHistory/fetchStations'),
        this.$store.cache.dispatch('cleanerHistory/fetchCars'),
        this.$store.cache.dispatch('cleanerHistory/fetchCarInStations'),
        this.$store.dispatch('cleanerHistory/fetchCleanerHistory', payload)
      ]
      Promise.all(promises).then(
        () => {
          this.$store.dispatch('cleanerHistory/composeHistoryData')
          this.$store.commit('cleanerHistory/setIsFetching', false)
        }
      )
    },
    loadCleaners () {
      server.get('/sso/getUA_Cleaners').then(
        resp => {
          this.cleaners = resp.data.msgContent.data
        }
      )
    },
    exportReport () {
      let datas = this.items
      let keys = ['LOG_DATE', 'CIST.STATION.NAME', 'CIST.CAR.NAME', 'CIST.CAR.LICENSE_PLATE', 'STATUS']
      let headers = ['Log Date', 'Station Name', 'Car Name', 'License Plate', 'Status']

      // Change status inside datas from number to string
      datas = datas.map(obj => ({
        ...obj,
        STATUS: obj.STATUS === 1 ? 'Reviewed' : 'Unreviewed'
      }))

      let cleaner = this.cleaners.find(cleaner => cleaner.CODE === this.selectedCleaner)
      const FILENAME = `VMTS_${cleaner.USER_PROFILE_FIRST_NAME}${cleaner.USER_PROFILE_LAST_NAME}_
        ${this.reportRange[this.tabIndex]}_REPORT_${moment(this.dateFilter).format('YYYY-MM-DD')}`

      let wb = helperService.exportToExcel(datas, headers, keys)
      wb.writeToBuffer().then((buffer) => {
        let data = new Blob([buffer])
        FileSaver.saveAs(data, `${FILENAME}.xlsx`)
        toastr.info('File has been downloaded')
      })

    }
  },
}
</script>
